// src/components/InstagramFeed.js
import React, { useEffect } from "react";
import { Container } from "react-bootstrap";

const InstagramFeed = () => {
  useEffect(() => {
    // Carrega o script do Instagram para embeber posts
    const script = document.createElement("script");
    script.src = "https://www.instagram.com/embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section className="instagram-section">
      <Container>
        <h2 className="text-center">Siga-nos no Instagram</h2>
        <div className="d-flex justify-content-center mt-4">
          <blockquote
            className="instagram-media"
            data-instgrm-permalink="https://www.instagram.com/amarante_pet/"
            data-instgrm-version="13"
            style={{
              background: "#FFF",
              border: "0",
              margin: "1px",
              maxWidth: "1000px",
              minWidth: "326px",
              padding: "0",
              width: "calc(100% - 2px)",
            }}
          >
            <div style={{ padding: "16px" }}>
              {/* Conteúdo do post do Instagram será embutido aqui */}
            </div>
          </blockquote>
        </div>
      </Container>
    </section>
  );
};

export default InstagramFeed;
